module.exports = __webpack_public_path__ + "img/button_delete_template.d8f71b6b.svg";